function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDeleteRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 28h16V9h2v19a2 2 0 01-2 2H8a2 2 0 01-2-2V9h2v19zm5-2h-2V11h2v15zm4 0h-2V11h2v15zm4 0h-2V11h2v15zM16 2a3 3 0 013 3h9v2H4V5h9a3 3 0 013-3z",
    fill: props.color
  }));
}

export default SvgIconDeleteRexOutline;